(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[269],{

/***/ 6191:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/contact",
      function () {
        return __webpack_require__(1982);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/detect-browser/es/index.js
var es = __webpack_require__(3631);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/OutdatedBrowser/OutdatedBrowser.module.css
var OutdatedBrowser_module = __webpack_require__(5193);
var OutdatedBrowser_module_default = /*#__PURE__*/__webpack_require__.n(OutdatedBrowser_module);
;// CONCATENATED MODULE: ./components/OutdatedBrowser/index.js




function OutdatedBrowser(param) {
    var visible = param.visible;
    var ref = (0,react.useState)(visible), mounted = ref[0], setMounted = ref[1];
    var handleClick = function() {
        setMounted(false);
    };
    if (!mounted) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OutdatedBrowser_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (OutdatedBrowser_module_default()).title,
                children: "Your browser is out-of-date!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (OutdatedBrowser_module_default()).text,
                children: "Please update your browser to view this website correctly."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://browser-update.org/update-browser.html",
                target: "_blank",
                rel: "noopener noreferrer",
                className: (OutdatedBrowser_module_default()).link,
                children: "Update my browser"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (OutdatedBrowser_module_default()).btn,
                onClick: handleClick
            })
        ]
    });
}
OutdatedBrowser.propTypes = {
    visible: (prop_types_default()).bool
};
OutdatedBrowser.defaultProps = {
    visible: false
};
/* harmony default export */ var components_OutdatedBrowser = (OutdatedBrowser);

// EXTERNAL MODULE: ./components/Footer/index.js + 1 modules
var Footer = __webpack_require__(6195);
// EXTERNAL MODULE: ./components/Layout/Layout.module.css
var Layout_module = __webpack_require__(1627);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./components/Layout/index.js







function Layout(param) {
    var children = param.children, footerLess = param.footerLess, className = param.className, globalSettings = param.globalSettings, contentClassName = param.contentClassName;
    var browser = (0,es/* detect */.qY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OutdatedBrowser, {
                visible: browser && browser.name === "ie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "layout",
                className: classnames_default()((Layout_module_default()).main, contentClassName),
                children: children
            }),
            !footerLess && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                globalSettings: globalSettings
            })
        ]
    });
}
Layout.propTypes = {
    className: (prop_types_default()).string,
    footerLess: (prop_types_default()).bool,
    globalSettings: (prop_types_default()).object,
    contentClassName: (prop_types_default()).string
};
Layout.defaultProps = {
    footerLess: false,
    className: "",
    globalSettings: {},
    contentClassName: ""
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 2583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Loading_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9152);
/* harmony import */ var _Loading_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Loading_module_css__WEBPACK_IMPORTED_MODULE_2__);




function Loading(param) {
    var initialColours = param.initialColours, hideLinks = param.hideLinks, className = param.className, children = param.children;
    var initialPageColour = initialColours.initialPageColour, initialUiColour = initialColours.initialUiColour;
    var setInitialPageColour = initialPageColour ? initialPageColour : "#fff";
    var setInitialUiColour = initialUiColour ? initialUiColour : "#000";
    // const setInitialTextColour = initialTextColour ? initialTextColour : '#000'
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: "body { background-color: ".concat(initialPageColour, " }\n            #header *,\n            #header-title * {\n              color: ").concat(hideLinks ? initialPageColour : initialUiColour, "!important\n            }\n            #header *::before,\n            #header *::after,\n            #header-title-line { \n              background-color: ").concat(hideLinks ? initialPageColour : initialUiColour, "!important\n            }")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Loading_module_css__WEBPACK_IMPORTED_MODULE_2___default().container), (classnames__WEBPACK_IMPORTED_MODULE_1___default())),
                style: {
                    backgroundColor: setInitialPageColour
                },
                children: children
            })
        ]
    });
}
Loading.propTypes = {
    initialColours: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
    hideLinks: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
};
Loading.defaultProps = {
    initialColours: {},
    hideLinks: false,
    className: "",
    children: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 1610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var html_entities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9111);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7821);
/* harmony import */ var helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(406);
/* harmony import */ var _helpers_isModellinkSite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2084);








var htmlEntities = new html_entities__WEBPACK_IMPORTED_MODULE_3__/* .Html5Entities */ .JK();
function htmlDecode() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return htmlEntities.decode(string);
}
function WordpressSEO(param) {
    var url = param.url, title = param.title, seo = param.seo, image = param.image, desc = param.desc, _canonical = param.canonical, canonical = _canonical === void 0 ? null : _canonical;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var siteName;
    var fallbackTitle;
    var siteLogo;
    if ((0,_helpers_isModellinkSite__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)()) {
        siteName = "Modellink";
        fallbackTitle = "".concat(htmlDecode(title), " | ").concat(siteName);
        siteLogo = "/img/logo/modellink.jpg";
    } else {
        var ref2;
        siteName = "Select Model Management";
        fallbackTitle = "".concat(htmlDecode(title)).concat(((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.site) ? " | Select ".concat((0,helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(router.query.site)) : "", " | ").concat(siteName);
        siteLogo = "/img/logo/selectmodel.jpg";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seo && seo.title ? htmlDecode(seo.title) : fallbackTitle,
        description: (seo === null || seo === void 0 ? void 0 : seo.metaDesc) || desc || siteName,
        openGraph: {
            title: seo === null || seo === void 0 ? void 0 : seo.title,
            url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LIVE_SITE_URL */ .WJ).concat(url),
            description: seo === null || seo === void 0 ? void 0 : seo.metaDesc,
            images: [
                {
                    url: image || (seo === null || seo === void 0 ? void 0 : (ref = seo.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LIVE_SITE_URL */ .WJ).concat(siteLogo)
                }, 
            ]
        },
        canonical: canonical
    });
}
WordpressSEO.propTypes = {
    url: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    desc: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    image: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    canonical: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    seo: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
WordpressSEO.defaultProps = {
    url: "",
    title: "",
    desc: null,
    image: "",
    seo: {},
    canonical: null
};
/* harmony default export */ __webpack_exports__["Z"] = (WordpressSEO);


/***/ }),

/***/ 406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uppercaseFirst; }
/* harmony export */ });
function uppercaseFirst(string) {
    if (!string) return null;
    return "".concat(string.charAt(0).toUpperCase()).concat(string.substring(1));
}


/***/ }),

/***/ 1982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./helpers/graphqlQuery.js
var graphqlQuery = __webpack_require__(61);
// EXTERNAL MODULE: ./context/GlobalContextProvider.js + 6 modules
var GlobalContextProvider = __webpack_require__(260);
// EXTERNAL MODULE: ./context/SitesContextProvider.js
var SitesContextProvider = __webpack_require__(9563);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(5063);
;// CONCATENATED MODULE: ./graphql/contact.query.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query CONTACT_QUERY {\n    offices {\n      nodes {\n        title\n        acfOffices {\n          contactDetails\n          address\n          contacts {\n            title\n            contactInfo {\n              link {\n                target\n                title\n                url\n              }\n              text\n            }\n            link {\n              target\n              title\n              url\n            }\n          }\n          facebookHandle\n          instagramHandle\n          latitude\n          longitude\n          mapLink\n          twitterHandle\n          tiktokHandle\n        }\n      }\n    }\n    pageBy(uri: "Contact") {\n      title\n      seo {\n        title\n        metaDesc\n        removeBlogTitle\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CONTACT_QUERY = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var contact_query = (CONTACT_QUERY);

// EXTERNAL MODULE: ./components/Layout/index.js + 1 modules
var Layout = __webpack_require__(3825);
// EXTERNAL MODULE: ./components/WordpressSEO/index.js
var WordpressSEO = __webpack_require__(1610);
// EXTERNAL MODULE: ./components/Loading/index.js
var Loading = __webpack_require__(2583);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./pages/[site]/contact.module.css
var contact_module = __webpack_require__(6965);
var contact_module_default = /*#__PURE__*/__webpack_require__.n(contact_module);
;// CONCATENATED MODULE: ./pages/[site]/contact.js


















var DynamicGoogleMap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(323), __webpack_require__.e(613)]).then(__webpack_require__.bind(__webpack_require__, 2584));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2584)
            ];
        }
    }
});
// todo: add propTypes
function Contact(param) {
    var site = param.site, initialTitle = param.title, seo = param.seo, loadedOffices = param.offices, globalSettings = param.globalSettings;
    var sites = (0,react.useContext)(SitesContextProvider/* SitesContext */.y).sites;
    var state = (0,react.useContext)(GlobalContextProvider/* GlobalStateContext */.Pn);
    var ref = (0,react.useState)(site), activeSite = ref[0], setActiveSite = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(loadedOffices), offices = ref2[0], setOffices = ref2[1];
    (0,react.useEffect)(function() {
        if (!offices[activeSite]) {
            setLoading(true);
            var fetchData = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(aSite) {
                    var ref, newOffices;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,graphqlQuery/* default */.Z)(contact_query, activeSite)
                                ];
                            case 1:
                                ref = _state.sent(), newOffices = ref.offices;
                                setOffices(function(cur) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur), (0,_define_property/* default */.Z)({}, aSite, newOffices.nodes));
                                });
                                setLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchData(aSite) {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchData(activeSite);
        }
    }, [
        activeSite
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WordpressSEO/* default */.Z, {
                    url: "/".concat(site, "/contact"),
                    title: initialTitle,
                    seo: seo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            ]
        });
    }
    if (!offices || !offices[activeSite]) return null;
    var office = offices[activeSite][0];
    var officeTitle = office.title, _acfOffices = office.acfOffices, address = _acfOffices.address, contactDetails = _acfOffices.contactDetails, contacts = _acfOffices.contacts, latitude = _acfOffices.latitude, longitude = _acfOffices.longitude, mapLink = _acfOffices.mapLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WordpressSEO/* default */.Z, {
                url: "/".concat(site, "/contact"),
                title: officeTitle,
                seo: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((contact_module_default()).container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (contact_module_default()).left,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (contact_module_default()).content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (contact_module_default()).title,
                                    children: officeTitle
                                }),
                                contactDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (contact_module_default()).contactDetails,
                                    dangerouslySetInnerHTML: {
                                        __html: contactDetails
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (contact_module_default()).boards,
                                    children: contacts === null || contacts === void 0 ? void 0 : contacts.map(function(param) {
                                        var title = param.title, link = param.link, contactInfo = param.contactInfo;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: (contact_module_default()).board,
                                            children: [
                                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: (contact_module_default()).boardTitle,
                                                    children: (link === null || link === void 0 ? void 0 : link.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: link.url,
                                                        className: (contact_module_default()).boardLink,
                                                        children: title
                                                    }) : title
                                                }),
                                                contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.map(function(param) {
                                                    var link = param.link, text = param.text;
                                                    if (!link) return null;
                                                    return (link === null || link === void 0 ? void 0 : link.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: link.url,
                                                        className: (contact_module_default()).boardLink,
                                                        children: text
                                                    }, link.url) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (contact_module_default()).boardLink,
                                                        children: text
                                                    }, link.url);
                                                })
                                            ]
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (contact_module_default()).right,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicGoogleMap, {
                            latitude: latitude,
                            longitude: longitude,
                            markerLink: mapLink,
                            info: address
                        })
                    })
                ]
            }),
            sites && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (contact_module_default()).locationsWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (contact_module_default()).locations,
                    children: sites.map(function(param) {
                        var id = param.id, name = param.name, path = param.path;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                return setActiveSite(path.replace(/\//g, ""));
                            },
                            className: classnames_default()((contact_module_default()).location, (0,_define_property/* default */.Z)({}, (contact_module_default()).locationActive, name === activeSite.charAt(0).toUpperCase() + activeSite.slice(1))),
                            children: name
                        }, id);
                    })
                })
            })
        ]
    });
}
Contact.propTypes = {
    seo: (prop_types_default()).object,
    offices: (prop_types_default()).object,
    globalSettings: (prop_types_default()).object
};
Contact.defaultProps = {
    seo: {},
    offices: {},
    globalSettings: {}
};
var __N_SSG = true;
/* harmony default export */ var contact = (Contact);


/***/ }),

/***/ 1627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Layout_spacing--xxxs__8iHw7","spacing--xxs":"Layout_spacing--xxs__rg8b2","spacing--xs":"Layout_spacing--xs__dO6OG","spacing--sm":"Layout_spacing--sm__jhGe9","spacing--md":"Layout_spacing--md__vIpF7","spacing--lg":"Layout_spacing--lg__fEe2_","spacing--xl":"Layout_spacing--xl__dhV28","spacing--xxl":"Layout_spacing--xxl__K3sH1","spacing--xxxl":"Layout_spacing--xxxl__Bs9tG","main":"Layout_main__gbdP0","fadeInItems":"Layout_fadeInItems__QzPHk"};

/***/ }),

/***/ 9152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Loading_spacing--xxxs__mrBZx","spacing--xxs":"Loading_spacing--xxs__gJPeb","spacing--xs":"Loading_spacing--xs__f8_dP","spacing--sm":"Loading_spacing--sm__BQT8f","spacing--md":"Loading_spacing--md__wjnkH","spacing--lg":"Loading_spacing--lg__vQy0F","spacing--xl":"Loading_spacing--xl__4069e","spacing--xxl":"Loading_spacing--xxl__MMJcu","spacing--xxxl":"Loading_spacing--xxxl__uHHvb","container":"Loading_container__gSMkV","fadeInItems":"Loading_fadeInItems__IBCzh"};

/***/ }),

/***/ 5193:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"OutdatedBrowser_spacing--xxxs__Accab","spacing--xxs":"OutdatedBrowser_spacing--xxs__i92K8","spacing--xs":"OutdatedBrowser_spacing--xs__zWpQI","spacing--sm":"OutdatedBrowser_spacing--sm__Vrmq_","spacing--md":"OutdatedBrowser_spacing--md__vcPS_","spacing--lg":"OutdatedBrowser_spacing--lg__SYnnw","spacing--xl":"OutdatedBrowser_spacing--xl__Mc5r2","spacing--xxl":"OutdatedBrowser_spacing--xxl___59QJ","spacing--xxxl":"OutdatedBrowser_spacing--xxxl__S_A_A","container":"OutdatedBrowser_container__5_uvZ","title":"OutdatedBrowser_title___0088","text":"OutdatedBrowser_text__aSnM3","link":"OutdatedBrowser_link__HM2Bc","btn":"OutdatedBrowser_btn__r3Ac0","fadeInItems":"OutdatedBrowser_fadeInItems__7725t"};

/***/ }),

/***/ 6965:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"contact_spacing--xxxs__JQht_","spacing--xxs":"contact_spacing--xxs__qFgsb","spacing--xs":"contact_spacing--xs__TYboQ","spacing--sm":"contact_spacing--sm__8wbNo","spacing--md":"contact_spacing--md__tiLZ8","spacing--lg":"contact_spacing--lg__thMK4","spacing--xl":"contact_spacing--xl__tJhtz","spacing--xxl":"contact_spacing--xxl__w1yHO","spacing--xxxl":"contact_spacing--xxxl__FPL3U","container":"contact_container__XvpCr","containerScrollable":"contact_containerScrollable__YGkx_","left":"contact_left__6YQVx","alternateMessage":"contact_alternateMessage__rhXSm","content":"contact_content__m2pSA","title":"contact_title__6GTWt","contactDetails":"contact_contactDetails__mDgY4","boards":"contact_boards__hgxwz","board":"contact_board___FZfJ","boardTitle":"contact_boardTitle__uHSBR","boardLink":"contact_boardLink__2BSkf","selectNewPrimaryAgency":"contact_selectNewPrimaryAgency__dRWl5","selectNewPrimaryAgencyIntro":"contact_selectNewPrimaryAgencyIntro__f812a","selectNewPrimaryAgencyItem":"contact_selectNewPrimaryAgencyItem__K2Nk0","backButton":"contact_backButton__U1qP1","right":"contact_right__zM_2Y","team":"contact_team__4xJIW","teamColumn":"contact_teamColumn__Pz5e_","teamColumnOffset":"contact_teamColumnOffset__Wz4oP","teamMember":"contact_teamMember__Vk14j","teamMemberImage":"contact_teamMemberImage__FGob1","teamMemberContent":"contact_teamMemberContent__pMPxP","teamMemberImageWrapper":"contact_teamMemberImageWrapper__INW5f","teamMemberTitle":"contact_teamMemberTitle__HO_U7","teamMemberPosition":"contact_teamMemberPosition__AfDWX","icon":"contact_icon__XNruA","selectedTeamMember":"contact_selectedTeamMember__Cz23y","selectedTeamMemberContent":"contact_selectedTeamMemberContent__uWXTK","selectedTeamMemberImageWrapper":"contact_selectedTeamMemberImageWrapper__EaN4n","selectedTeamMemberImage":"contact_selectedTeamMemberImage__jOT8G","selectedTeamMemberTitle":"contact_selectedTeamMemberTitle__kFJYG","selectedTeamMemberPosition":"contact_selectedTeamMemberPosition__6O8YE","selectedTeamMemberLink":"contact_selectedTeamMemberLink__YagkM","selectTeamMemberClose":"contact_selectTeamMemberClose__G1a1_","selectTeamMemberCloseIcon":"contact_selectTeamMemberCloseIcon__bF00d","locationsWrapper":"contact_locationsWrapper__rqt_s","locations":"contact_locations__bKrN3","location":"contact_location__HKo9u","locationActive":"contact_locationActive__YtsrG","fadeInItems":"contact_fadeInItems__qWGlO"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,774,888,179], function() { return __webpack_exec__(6191); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);